const styles = {
  details: {
    marginTop: "25px",
    marginBottom: "5px",
    backgroundColor: "orange",
    borderRadius: "12px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
  },
};

function GiveawayLink() {
  window.open("https://discord.gg/", "_blank");
}

function GiveAwayButton() {
  return (
    <div>
      <button
        style={styles.details}
        // disabled={!info.connected || mintInfo.cost == "0"}
        className="button"
        onClick={() => GiveawayLink()}
      >
        Participate in Giveaway!
      </button>
    </div>
  );
}

export default GiveAwayButton;
